export default __webpack_public_path__ + "static/media/check-with-kindly.0333fbb1.svg";